import { Body, Box, BoxProps } from '@hover/blueprint';
import React from 'react';
import { IPricingTableHeader } from '../../../interfaces/IPricingTableHeader';
import ArrowLink from '../../ui/ArrowLink';

interface Props extends BoxProps {
  card: IPricingTableHeader;
  onLinkClick: (card: IPricingTableHeader) => void;
}

const HeaderCard: React.FC<Props> = ({ card, onLinkClick, ...restProps }) => (
  <Box
    h={{ base: '160px', desktop: '170px' }}
    bg={card.background}
    borderRadius="8px"
    shadow="distance300"
    py={400}
    alignItems="center"
    flexDir="column"
    px="10px"
    {...restProps}
  >
    <Body
      size={{ base: 500, tablet: 600 }}
      fontWeight={700}
      textAlign="center"
      mb={100}
    >
      {card.name}
    </Body>
    <Body mb={200} textAlign="center" size={300} fontWeight={400}>
      {card.description}
    </Body>
    <ArrowLink
      as="button"
      justifyContent="center"
      isMinimal
      mt="auto"
      w="100%"
      onClick={() => onLinkClick(card)}
    >
      {card.buttonText}
    </ArrowLink>
  </Box>
);

export default HeaderCard;
